// Backwards-compatible helpers: old dishes keep their category and single price.
const categoryKey = (name = '') => String(name).normalize('NFKC').trim().toLocaleLowerCase('it');
function menuCategories(content) {
  const result = [], seen = new Set();
  for (const category of content?.categories || []) {
    const key = categoryKey(category.name);
    if (key && !seen.has(key)) { seen.add(key); result.push({ name: category.name.trim(), visible: category.visible !== false }); }
  }
  for (const item of content?.menu || []) {
    const key = categoryKey(item.category);
    if (key && !seen.has(key)) { seen.add(key); result.push({ name: item.category.trim(), visible: true }); }
  }
  return result;
}
function visibleMenu(content) {
  const hidden = new Set(menuCategories(content).filter(c => !c.visible).map(c => categoryKey(c.name)));
  return (content?.menu || []).filter(item => item.available !== false && !hidden.has(categoryKey(item.category)));
}
function dishPrice(item) {
  const prices = item.variants?.length ? item.variants.map(v => v.price) : [item.price];
  const valid = prices.filter(p => p !== '' && p != null && Number.isFinite(Number(p)));
  if (!valid.length || valid.length !== prices.length) return 'Prezzo da chiedere';
  const price = new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(Math.min(...valid.map(Number)));
  return `${item.variants?.length ? 'Da ' : ''}${price}`;
}
module.exports = { categoryKey, menuCategories, visibleMenu, dishPrice };
